(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cx-light-switch"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('cx-light-switch')){
  customElements.define('cx-light-switch',class extends HTMLElement{
    connectedCallback(){this.frame=requestAnimationFrame(()=>this.init())}
    disconnectedCallback(){cancelAnimationFrame(this.frame);this.controller?.abort()}
    init(){
      this.controller?.abort();this.controller=new AbortController();const signal=this.controller.signal;
      const button=this.querySelector('[data-toggle]');if(!button)return;
      const images=[...this.querySelectorAll('picture img')];
      const paint=lit=>{this.dataset.lit=String(lit);button.setAttribute('aria-pressed',String(lit));this.querySelector('[data-off-label]').hidden=lit;this.querySelector('[data-on-label]').hidden=!lit};
      const refresh=()=>{const ready=images.length===2&&images.every(img=>img.complete&&img.naturalWidth>0);button.hidden=!ready;if(ready&&!this.initialized){paint(this.dataset.initial==='on');this.initialized=true}};
      images.forEach(img=>{img.addEventListener('load',refresh,{signal});img.addEventListener('error',()=>{button.hidden=true;paint(false)},{signal})});
      button.addEventListener('click',()=>paint(this.dataset.lit!=='true'),{signal});refresh();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cx-version-cards"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('cx-version-section')){
  customElements.define('cx-version-section',class extends HTMLElement{
    connectedCallback(){
      this.cxLabels=new Map();this.cxFields=new Set();this.cxDoorAnimations=new Map();
      this.cxAbort=new AbortController();
      document.addEventListener('click',event=>this.cxClick(event),{capture:true,signal:this.cxAbort.signal});
      this.cxObserver=new MutationObserver(records=>{
        if(records.some(record=>this.cxTarget?.contains(record.target)||[...record.addedNodes,...record.removedNodes].some(node=>node.nodeType===1&&(node.matches('product-info')||node.querySelector('product-info')))))this.cxSchedule();
      });
      this.cxSchedule();
    }
    disconnectedCallback(){cancelAnimationFrame(this.cxFrame);this.cxObserver?.disconnect();this.cxAbort?.abort();this.cxRestore()}
    cxSchedule(){cancelAnimationFrame(this.cxFrame);this.cxFrame=requestAnimationFrame(()=>this.cxUpdate())}
    cxClick(event){
      const label=event.target.closest?.('label.cx-edition-card');
      const input=label?.control||(event.detail===0&&event.target.matches?.('input[type="radio"]')?event.target:null);
      if(!input||!this.cxTarget?.contains(input)||!input.closest('.cx-edition-field')||input.disabled||input.classList.contains('disabled'))return;
      const card=input.nextElementSibling;
      this.cxDoorAnimations.forEach(record=>record.animation.cancel());this.cxDoorAnimations.clear();this.cxDoorReplay=null;
      if(!card?.querySelector('.cx-edition-door>span'))return;
      this.cxDoorReplay={key:input.name+'|'+input.value,start:performance.now()};this.cxAnimateDoor(card,input);
    }
    cxAnimateDoor(label,input){
      const replay=this.cxDoorReplay;
      if(!replay||replay.key!==input.name+'|'+input.value||this.dataset.animate==='false'||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
      const leaf=label.querySelector('.cx-edition-door>span');const elapsed=performance.now()-replay.start;
      if(!leaf||elapsed>=900||this.cxDoorAnimations.get(leaf)?.start===replay.start)return;
      const animation=leaf.animate([{transform:'rotateY(0deg)',offset:0},{transform:'rotateY(0deg)',offset:.12},{transform:'rotateY(-82deg)',offset:.8},{transform:'rotateY(-75deg)',offset:1}],{duration:900,easing:'ease-in-out'});
      animation.currentTime=Math.max(0,elapsed);this.cxDoorAnimations.set(leaf,{animation,start:replay.start});
      animation.finished.then(()=>{if(this.cxDoorAnimations.get(leaf)?.animation===animation)this.cxDoorAnimations.delete(leaf)},()=>{});
    }
    cxRestore(){
      this.cxDoorAnimations?.forEach(record=>record.animation.cancel());this.cxDoorAnimations?.clear();this.cxDoorReplay=null;
      this.cxLabels?.forEach((saved,label)=>{label.replaceChildren(...saved.nodes);label.classList.remove('cx-edition-card');delete label.dataset.cxEditionValue;delete label.dataset.light;if(saved.aria===null)label.removeAttribute('aria-label');else label.setAttribute('aria-label',saved.aria)});
      this.cxLabels?.clear();this.cxFields?.forEach(field=>field.classList.remove('cx-edition-field'));this.cxFields?.clear();
      if(this.cxTarget){this.cxTarget.classList.remove('cx-edition-scope');this.cxTarget.removeAttribute('data-cx-edition-animation');this.cxStyles?.forEach(([name,value,priority])=>{if(value)this.cxTarget.style.setProperty(name,value,priority);else this.cxTarget.style.removeProperty(name)})}
      this.cxTarget=null;
    }
    cxUpdate(){
      this.cxObserver.disconnect();
      const target=[...document.querySelectorAll('product-info:not([data-original-section-id])')].find(info=>info.dataset.productId===this.dataset.productId&&info.querySelector('variant-picker'));
      if(this.dataset.enabled==='false'||!target){this.cxRestore();this.cxStatus(this.dataset.enabled==='false'?'卡片样式已关闭，原始选项已恢复。':'等待产品信息区块。请保留主题原有的变体选择器。');this.cxObserve();return}
      if(target!==this.cxTarget){
        this.cxRestore();this.cxTarget=target;
        const variables={'--cx-edition-selected':this.dataset.selected,'--cx-edition-ink':this.dataset.ink,'--cx-edition-surface':this.dataset.surface?.toLowerCase()==='#f4f5f1'?'#ffffff':this.dataset.surface,'--cx-edition-glow':this.dataset.glow,'--cx-edition-width':this.dataset.width+'px','--cx-edition-height':this.dataset.height+'px','--cx-edition-radius':this.dataset.radius+'px','--cx-edition-columns':this.dataset.columns};
        this.cxStyles=Object.entries(variables).map(([name,value])=>{const saved=[name,target.style.getPropertyValue(name),target.style.getPropertyPriority(name)];target.style.setProperty(name,value);return saved});
        target.classList.add('cx-edition-scope');target.dataset.cxEditionAnimation=this.dataset.animate;
      }
      this.cxLabels.forEach((saved,label)=>{if(!target.contains(label))this.cxLabels.delete(label)});
      this.cxFields.forEach(field=>{if(!target.contains(field))this.cxFields.delete(field)});
      this.cxDoorAnimations.forEach((record,leaf)=>{if(!target.contains(leaf)){record.animation.cancel();this.cxDoorAnimations.delete(leaf)}});
      let matches=0;
      const wanted=(this.dataset.optionName||'').trim().toLocaleLowerCase();
      target.querySelectorAll('variant-picker fieldset').forEach(field=>{
        if(field.closest('product-info, product-card-info')!==target)return;
        const inputs=[...field.querySelectorAll('input[type="radio"]')];
        const optionName=field.querySelector('legend')?.textContent.trim().toLocaleLowerCase();
        const known=wanted?optionName===wanted:inputs.some(input=>/^(deluxe|premium|standard|delux|premi[eé]re|estándar|estandar|estàndard|est[áa]ndar|standardní|standaard|standar|lyx|prémiov|premi[óo]v)|^(豪华|高级|标准|基础)版|^(プレミアム|スタンダード|標準|デラックス|الفاخرة|فاخر|ديلوكس|بريميوم|قياسي|القياسي|مميز|المميز|أساسي|الأساسي)/i.test(input.value.trim()));
        if(!known)return;
        inputs.forEach(input=>{
          const label=input.nextElementSibling;
          if(!label?.matches('label.label-swatch')||label.htmlFor!==input.id)return;
          matches++;field.classList.add('cx-edition-field');this.cxFields.add(field);
          if(label.dataset.cxEditionValue===input.value){if(input.checked)this.cxAnimateDoor(label,input);return}
          if(!this.cxLabels.has(label))this.cxLabels.set(label,{nodes:[...label.childNodes],aria:label.getAttribute('aria-label')});
          const value=input.value.trim();const split=value.match(/^([^()（）]+?)\s*[（(]([\s\S]*)[)）]\s*$/);
          const title=split?split[1].trim():value;const subtitle=split?split[2].trim():'';
          const noLight=/no\s*lights?|without\s*(led|lights?)|unlit|ohne|sans|sin\s*(luz|luces|led)|senza|zonder|utan|bez\s*(světel|osvětlení|led)|tanpa|بدون|دون\s*إضاءة|ライトなし|照明なし|無灯|无灯|不带灯/i.test(value);
          const light=!noLight&&(/\bled\b|lights?|beleuchtung|éclairage|iluminaci[oó]n|illuminazione|verlichting|belysning|osvětlení|lampu|إضاءة|ライト|照明|灯/i.test(value));
          const door=/opening|cargo\s*bay|frachtraum|laderaum|soute|bodega|stiva|laadruim|lastrum|nákladov|ruang\s*kargo|عنبر|شحن|貨物|カーゴ|开舱|舱门/i.test(value);
          label.classList.add('cx-edition-card');label.dataset.cxEditionValue=input.value;label.dataset.light=String(light);label.setAttribute('aria-label',input.value);
          const motif=document.createElement('span');motif.className='cx-edition-motif';motif.setAttribute('aria-hidden','true');
          for(let i=0;i<(door?3:4);i++){const window=document.createElement('i');window.className='cx-edition-window';motif.append(window)}
          if(door){const hatch=document.createElement('i');hatch.className='cx-edition-door';hatch.append(document.createElement('span'));motif.append(hatch)}
          const heading=document.createElement('span');heading.className='cx-edition-title';heading.textContent=title;
          const check=document.createElement('span');check.className='cx-edition-check';check.setAttribute('aria-hidden','true');check.innerHTML='<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2"><path d="m3 8 3 3 7-7"/></svg>';
          label.replaceChildren(motif,heading);
          if(subtitle){const sub=document.createElement('span');sub.className='cx-edition-subtitle';sub.textContent=subtitle;label.append(sub)}
          label.append(check);
          if(input.checked)this.cxAnimateDoor(label,input);
        });
      });
      this.cxStatus(matches?'已启用：卡片显示在产品信息原来的版本选项位置。':'未找到按钮式版本选项。请将原变体选择器设为“按钮”，或在本板块填写准确的选项名称。');
      this.cxObserve();
    }
    cxStatus(message){const status=this.querySelector('[data-cx-status]');if(status&&status.textContent!==message)status.textContent=message}
    cxObserve(){if(this.isConnected)this.cxObserver.observe(document.body,{childList:true,subtree:true})}
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

if(!customElements.get('cx-meta-tabs')){
  customElements.define('cx-meta-tabs',class extends HTMLElement{
    connectedCallback(){this.cxFrame=requestAnimationFrame(()=>this.cxInit())}
    disconnectedCallback(){cancelAnimationFrame(this.cxFrame);cancelAnimationFrame(this.cxRailFrame);this.cxAbort?.abort();this.cxAnimation?.cancel();this.cxResize?.disconnect()}
    cxPlace(){
      const key=this.dataset.cxPlacementKey;
      const scope=this.closest('.shopify-section');
      if(!key||!scope)return;
      const media=[...scope.querySelectorAll('template[data-cx-meta-media-slot]')].find(el=>el.dataset.cxMetaMediaSlot===key);
      const info=[...scope.querySelectorAll('template[data-cx-meta-info-slot]')].find(el=>el.dataset.cxMetaInfoSlot===key);
      const below=(matchMedia('(min-width:1024px)').matches?this.dataset.cxDesktopMedia:this.dataset.cxMobileMedia)==='true';
      const anchor=(below&&media)?media:info;
      if(!anchor)return;
      const slot=media?.closest('.cx-meta-media-slot');
      if(slot)slot.hidden=anchor!==media;
      if(anchor.nextSibling!==this)anchor.after(this);
    }
    cxInit(){
      this.cxAbort?.abort();this.cxAbort=new AbortController();const signal=this.cxAbort.signal;
      const nav=this.querySelector('[data-cx-nav]');const tabs=[...this.querySelectorAll('[data-cx-tab]')];const panels=[...this.querySelectorAll('[data-cx-panel]')];
      if(!nav||!tabs.length||tabs.length!==panels.length)return;
      const uid='cx-meta-'+crypto.randomUUID();const motion=()=>this.dataset.animateTabs!=='false'&&!matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.cxResize?.disconnect();
      const rails=[...this.querySelectorAll('.cx-meta-tabs__cards')];
      const updates=[];
      rails.forEach((rail,railIndex)=>{
        let wrap=rail.parentElement;
        if(!wrap.classList.contains('cx-meta-tabs__rail-wrap')){
          wrap=document.createElement('div');wrap.className='cx-meta-tabs__rail-wrap';rail.before(wrap);wrap.append(rail);
        }
        rail.id=uid+'-rail-'+railIndex;
        rail.setAttribute('aria-label',this.dataset.scrollLabel||'Browse items');
        const buttons=['prev','next'].map((name,index)=>{
          let button=wrap.querySelector('.cx-meta-tabs__arrow--'+name);
          if(!button){
            button=document.createElement('button');button.type='button';button.className='cx-meta-tabs__arrow cx-meta-tabs__arrow--'+name;
            button.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="'+(index?'m9 6 6 6-6 6':'m15 6-6 6 6 6')+'"/></svg>';wrap.append(button);
          }
          button.setAttribute('aria-controls',rail.id);button.setAttribute('aria-label',(this.dataset.scrollLabel||'Browse items')+(index?' →':' ←'));
          return button;
        });
        const max=()=>Math.max(0,rail.scrollWidth-rail.clientWidth);
        const position=()=>Math.abs(rail.scrollLeft);
        const direction=()=>getComputedStyle(rail).direction==='rtl'?-1:1;
        const update=()=>{const distance=max();const overflow=rail.clientWidth>0&&distance>2;rail.tabIndex=overflow?0:-1;buttons.forEach(button=>button.hidden=!overflow);buttons[0].disabled=position()<2;buttons[1].disabled=position()>distance-2};
        const move=step=>rail.scrollBy({left:direction()*step*Math.max(100,rail.clientWidth*.75),behavior:motion()?'smooth':'instant'});
        updates.push(update);rail.addEventListener('scroll',update,{signal,passive:true});rail.addEventListener('load',update,{signal,capture:true});
        buttons.forEach((button,index)=>button.addEventListener('click',()=>move(index?1:-1),{signal}));
        rail.addEventListener('keydown',event=>{if(event.target!==rail)return;if(['ArrowLeft','ArrowRight','Home','End'].includes(event.key)){event.preventDefault();if(event.key==='Home'||event.key==='End')rail.scrollTo({left:event.key==='Home'?0:direction()*max(),behavior:motion()?'smooth':'instant'});else move((event.key==='ArrowRight'?1:-1)*direction())}},{signal});
      });
      const updateRails=()=>updates.forEach(fn=>fn());
      this.cxResize=new ResizeObserver(updateRails);rails.forEach(rail=>this.cxResize.observe(rail));

      let active=0;
      const activate=(index,focus=false,animate=true)=>{
        const changed=index!==active;active=index;this.cxActiveIndex=index;this.style.setProperty('--cx-index',index);
        this.cxAnimation?.cancel();
        tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;panels[i].hidden=i!==index});
        if(changed&&animate&&motion())this.cxAnimation=panels[index].animate([{opacity:0,transform:'translateY(5px)'},{opacity:1,transform:'translateY(0)'}],{duration:220,easing:'ease-out'});
        if(focus)tabs[index].focus();
        cancelAnimationFrame(this.cxRailFrame);this.cxRailFrame=requestAnimationFrame(updateRails);
      };
      nav.hidden=false;nav.setAttribute('role','tablist');
      tabs.forEach((tab,i)=>{
        tab.id=uid+'-tab-'+i;tab.setAttribute('role','tab');tab.setAttribute('aria-controls',uid+'-panel-'+i);
        panels[i].id=uid+'-panel-'+i;panels[i].setAttribute('role','tabpanel');panels[i].setAttribute('aria-labelledby',tab.id);panels[i].tabIndex=0;
        tab.addEventListener('click',()=>activate(i),{signal});
        tab.addEventListener('keydown',e=>{
          if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();
          let index=e.key==='Home'?0:e.key==='End'?tabs.length-1:(i+1)%tabs.length;activate(index,true);
        },{signal});
      });
      this.setAttribute('data-ready','');activate(Math.min(this.cxActiveIndex||0,tabs.length-1),false,false);
      matchMedia('(min-width:1024px)').addEventListener('change',()=>this.cxPlace(),{signal});
      this.cxPlace();
    }
  });
}


if(!customElements.get('cx-discount-inline')){
customElements.define('cx-discount-inline',class extends HTMLElement{
connectedCallback(){this.frame=requestAnimationFrame(()=>this.init())}
disconnectedCallback(){cancelAnimationFrame(this.frame);clearTimeout(this.timer);this.resize?.disconnect();this.abort?.abort()}
init(){
this.abort?.abort();this.abort=new AbortController();const signal=this.abort.signal;const button=this.querySelector('[data-cxdi-copy]'),details=this.querySelector('details'),status=this.querySelector('[data-cxdi-status]');
this.addEventListener('shopify:block:select',()=>{if(details)details.open=true},{signal});
this.resize?.disconnect();
if(details){const summary=details.querySelector('summary');const measure=()=>{if(summary)this.style.setProperty('--cxdi-measured-header',summary.getBoundingClientRect().height+'px')};this.resize=new ResizeObserver(measure);if(summary)this.resize.observe(summary);measure()}
if(!button)return;button.hidden=false;button.disabled=false;const label=button.dataset.originalLabel||button.textContent;button.dataset.originalLabel=label;button.textContent=label;
button.addEventListener('click',async()=>{
clearTimeout(this.timer);button.disabled=true;status.textContent='';const code=this.dataset.code||'';let copied=false;
try{if(navigator.clipboard?.writeText){await navigator.clipboard.writeText(code);copied=true}}catch(error){}
if(signal.aborted)return;
if(!copied){const input=document.createElement('textarea');input.value=code;input.readOnly=true;input.setAttribute('aria-hidden','true');input.style.cssText='position:fixed;left:-9999px;top:0;font-size:16px';this.append(input);input.select();input.setSelectionRange(0,input.value.length);try{copied=document.execCommand('copy')}catch(error){}input.remove();button.focus({preventScroll:true})}
if(signal.aborted)return;button.disabled=false;
if(copied){button.textContent=this.dataset.copied;status.textContent=this.dataset.copied;this.timer=setTimeout(()=>{button.textContent=label;status.textContent=''},2400)}else{button.textContent=label;status.textContent=(this.dataset.failed||'')+' '+code}
},{signal});
}
});
}

if (!customElements.get('cx-native-guide-button')) {
  customElements.define('cx-native-guide-button', class extends HTMLElement {
    static opened = new Set();
    static oldOverflow = '';
    static oldPriority = '';
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.trigger = this.querySelector('.cxng__trigger');
      this.dialog = this.querySelector('dialog');
      if (!this.trigger || !this.dialog) return;
      this.trigger.addEventListener('click', () => this.open(), options);
      this.querySelector('.cxng__close').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => {if(!this.dialog.open)this.release()}, options);
      this.dialog.addEventListener('keydown', e => {
        if(e.key!=='Tab')return;
        const elements=Array.from(this.dialog.querySelectorAll('a[href],button,input,select,textarea,[tabindex]')).filter(el=>!el.disabled && el.tabIndex>=0 && el.getClientRects().length);
        const first=elements[0],last=elements[elements.length-1];
        if(e.shiftKey && document.activeElement===first){e.preventDefault();last?.focus()}
        else if(!e.shiftKey && document.activeElement===last){e.preventDefault();first?.focus()}
      }, options);
      const outside = e => {
        const r=this.dialog.getBoundingClientRect();
        return e.clientX<r.left || e.clientX>r.right || e.clientY<r.top || e.clientY>r.bottom;
      };
      this.dialog.addEventListener('pointerdown', e => {this.startedOutside=e.target===this.dialog && outside(e)}, options);
      this.dialog.addEventListener('click', e => {if(this.startedOutside && e.target===this.dialog && outside(e)) this.dialog.close();this.startedOutside=false}, options);
      this.addEventListener('shopify:block:select', () => this.open(), options);
      this.addEventListener('shopify:block:deselect', () => this.dialog.close(), options);
    }
    open() {
      if (this.dialog.open || !this.isConnected) return;
      this.dialog.showModal();
      this.dialog.scrollTop=0;
      this.trigger.setAttribute('aria-expanded','true');
      const C=this.constructor;
      if(!C.opened.size){C.oldOverflow=document.documentElement.style.getPropertyValue('overflow');C.oldPriority=document.documentElement.style.getPropertyPriority('overflow')}
      C.opened.add(this);
      document.documentElement.style.setProperty('overflow','hidden','important');
    }
    release() {
      this.trigger?.setAttribute('aria-expanded','false');
      const C=this.constructor;
      if(!C.opened.delete(this)) return;
      if(!C.opened.size){if(C.oldOverflow)document.documentElement.style.setProperty('overflow',C.oldOverflow,C.oldPriority);else document.documentElement.style.removeProperty('overflow')}
    }
    disconnectedCallback() {
      if(this.dialog?.open)this.dialog.close();
      this.release();
      this.abort?.abort();
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
